export const pdfViewer_style = {};
